import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormGroup } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { media } from '../../../../json-to-from/types/menu/media';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { Media } from './media';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { menuForm } from '../../../../json-to-from/types/menu/menuForm';

const NODE_TYPE = "media";

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent extends NodeBuilder implements OnInit {

  mediaForm: FormGroup = undefined;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE)
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.mediaForm = Media.toForm(stepData, this.canEdit);
    if (this.mediaForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep()
      this.mediaForm.get('next').setValue(this.newStep);
    }
  }

  get getStepData(): {} {
    const media = new Media();
    const rawValue = this.mediaForm.getRawValue();
    media.setMenu(rawValue);
    const nodeData = media.nodeData;

    if (!rawValue.endSession || rawValue.mediaDirection === 'inbound') {
      nodeData['next'] = rawValue.next;
    }

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.mediaForm.markAllAsTouched();
    return this.mediaForm.valid;
  }

  public sessionEndToggle(checked): void {
    this.mediaForm.get('endSession').setValue(checked);

    if (this.mediaForm.get('next').value === undefined) {
      if (this.newStep !== undefined) {
        this.mediaForm.get('next').setValue(this.newStep);
      }
      else {
        this.newStep = 'step' + this.getNextStep()
        this.mediaForm.get('next').setValue(this.newStep);
      }
    }
  }

  public directionChanged(event: MatButtonToggleGroup): void {
    this.mediaForm.get('mediaDirection').setValue(event.value);
  }

  public sourceChanged(event: MatButtonToggleGroup): void {
    this.mediaForm.get('varType').setValue(event.value);
  }

  setImage(event, form) {
    form.get('varName').setValue(event);
  }

  protected readonly menuForm = menuForm;
}